export interface State {
  auditLogPage: number;
  auditLogPageSize: number;
}

export const initialState: State = {
  auditLogPage: 1,
  auditLogPageSize: 30,
};
